<template>
    <div>
        <md-tabs @md-changed="changeTab" md-active-tab="tab-intervention-ended">
            <md-tab key="tab-intervention-new" id="tab-intervention-new" md-label="Nouvelle intervention"
                    @click.stop="goToRoute('Add Intervention')">
            </md-tab>
            <md-tab key="tab-intervention-ended" id="tab-intervention-ended" md-label="Interventions terminées">
                <intervention-ended title="Interventions terminées" :active="tabs[1].active"></intervention-ended>
            </md-tab>
            <md-tab key="tab-intervention-planned" id="tab-intervention-planned" md-label="Interventions prévues">
                <intervention-planned title="Interventions prévues" :active="tabs[2].active"></intervention-planned>
            </md-tab>
            <md-tab key="tab-intervention-canceled" id="tab-intervention-canceled" md-label="Interventions annulées">
                <intervention-canceled title="Interventions annulées" :active="tabs[3].active"></intervention-canceled>
            </md-tab>
        </md-tabs>
    </div>
</template>

<script>
import InterventionCanceled from "@/pages/Planning/Intervention/components/InterventionCanceled";
import InterventionPlanned from "@/pages/Planning/Intervention/components/InterventionPlanned";
import InterventionEnded from "@/pages/Planning/Intervention/components/InterventionEnded";

export default {
    name: "Interventions",
    components: {
        InterventionEnded,
        InterventionPlanned,
        InterventionCanceled,
    },
    data() {
        return {
            tabs: [
                {
                    id: 'tab-intervention-new', active: false
                },
                {
                    id: 'tab-intervention-ended', active: true
                },
                {
                    id: 'tab-intervention-planned', active: false
                },
                {
                    id: 'tab-intervention-canceled', active: false
                }
            ],
        }
    },
    methods: {
        changeTab(id = 'tab-intervention-ended') {
            this.tabs.map(tab => tab.active = false)
            let activeTab = this.tabs.find(tab => tab.id === id)
            activeTab.active = true
        },
        goToRoute(route) {
            this.$router.push({ name: route })
        }
    },
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-tabs {
        .md-tabs-navigation {
            margin: 10px 0;
            background: #fff !important;
            padding: 0;
            transition: all 150ms ease-in;
            -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
            box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);

            .md-tab-nav-button {
                background: transparent !important;
                color: rgba(0, 0, 0, 0.87) !important;
                min-width: max-content;

                :hover {
                    background: rgba(200, 200, 200, 0.2) !important;
                }

                .md-button-content:hover {
                    background: unset !important;
                }

                &.md-active {
                    border-bottom: 2px solid #dd4b39 !important;
                }
            }
        }

        .md-content {
            background: transparent !important;

            table {
                thead {
                    display: contents;
                }
            }

            .md-tab {
                padding: 0;
            }
        }
    }
}
</style>

